module.exports = __webpack_public_path__ + "img/kpxjt_left_select.5ec77f3e.png";